export const LineChartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M4.75 15.561a2 2 0 0 0 2.811-.313l2.789-3.486L12.8 13.6a2 2 0 0 0 2.762-.352l4-5a2 2 0 0 0-3.124-2.499l-2.789 3.486L11.2 7.4a2 2 0 0 0-2.762.35l-4 5a2 2 0 0 0 .312 2.811ZM5 21h14a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2" />
  </svg>
);
export const BarChartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64 64h64v298.667H64zm106.667 149.333h64v149.334h-64zM448 170.667h-64v192h64zm-170.667-64h64v256h-64zM448 405.333H64V448h384z"
    />
  </svg>
);
export const GridViewIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
      <path
        fill="currentColor"
        d="M9 13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm10 0a2 2 0 0 1 1.995 1.85L21 15v4a2 2 0 0 1-1.85 1.995L19 21h-4a2 2 0 0 1-1.995-1.85L13 19v-4a2 2 0 0 1 1.85-1.995L15 13zM9 15H5v4h4zm10 0h-4v4h4zm0-12a2 2 0 0 1 1.995 1.85L21 5v4a2 2 0 0 1-1.85 1.995L19 11h-4a2 2 0 0 1-1.995-1.85L13 9V5a2 2 0 0 1 1.85-1.995L15 3zM9 3a2 2 0 0 1 1.995 1.85L11 5v4a2 2 0 0 1-1.85 1.995L9 11H5a2 2 0 0 1-1.995-1.85L3 9V5a2 2 0 0 1 1.85-1.995L5 3zm10 2h-4v4h4zM9 5H5v4h4z"
      />
    </g>
  </svg>
);
export const ListViewIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 15q-.425 0-.712-.288T3 14t.288-.712T4 13h6q.425 0 .713.288T11 14t-.288.713T10 15zm0 4q-.425 0-.712-.288T3 18t.288-.712T4 17h6q.425 0 .713.288T11 18t-.288.713T10 19zm0-8q-.425 0-.712-.288T3 10t.288-.712T4 9h6q.425 0 .713.288T11 10t-.288.713T10 11zm0-4q-.425 0-.712-.288T3 6t.288-.712T4 5h6q.425 0 .713.288T11 6t-.288.713T10 7zm11 12q-.825 0-1.412-.587T13 17V7q0-.825.588-1.412T15 5h4q.825 0 1.413.588T21 7v10q0 .825-.587 1.413T19 19zm0-2h4V7h-4zm2-5"
    />
  </svg>
);
export const DonutChartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M13 6C15.507 6.423 17.577 8.493 18 11H22C21.529 6.283 17.717 2.471 13 2V6Z" fill="currentColor" />
    <path d="M17.9998 13C17.5218 15.833 15.0178 17.949 12.0508 17.949C8.74178 17.949 6.05078 15.258 6.05078 11.949C6.05078 8.982 8.16678 6.478 10.9998 6V2C5.95378 2.504 2.05078 6.773 2.05078 11.949C2.05078 17.463 6.53678 21.949 12.0508 21.949C17.2268 21.949 21.4958 18.046 21.9998 13H17.9998Z" fill="currentColor" />
  </svg>
);
export const InfoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeLinejoin="round"
    strokeWidth={1}
    {...props}
  >
    <g fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={1}>
      <circle
        cx="12"
        cy="12"
        r="9"
        strokeLinecap="round"
        strokeWidth={2}
      />
      <path
        strokeWidth={3}
        d="M12 8h.01v.01H12z"
      />
      <path
        strokeLinecap="round"
        strokeWidth={2}
        d="M12 12v4"
      />
    </g>
  </svg>
);




